import styled from 'styled-components';
import Colors from 'assets/Colors';

const IconWrapper = styled.div`
  display: grid;
  place-items: center;
  height: 32px;
  width: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 5px;

  ${(props) =>
    (props.selected
      ? `background: ${Colors.primary_web};`
      : `background: ${Colors.background_secondary}; box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.12), 0px 2px 4px -1px rgba(0, 0, 0, 0.07);`)}
`;

const ItemWrapper = styled.div`
  ${(props) =>
    (props.selected
      ? `background: ${Colors.background_secondary}; box-shadow: 0px 20px 27px rgba(0, 0, 0, 0.05); font-weight: 500;`
      : '')}
  border-radius: 5px;
  height: 32px;
  display: flex;
  align-items: center;
  margin-left: 18px;
  margin-right: 20px;
  margin-bottom: 13px;
  cursor: pointer;
`;

const TextWrapper = styled.div`
  font-style: normal;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
  margin-left: 11px;
`;

export default {
  IconWrapper,
  ItemWrapper,
  TextWrapper,
};
